import React, { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

interface AccountManagementProviderProps {
  showTable: boolean;
  handleShowTable: (payload: boolean) => void;
}

const defaultValue: AccountManagementProviderProps = {
  showTable: false,
  handleShowTable: () => undefined,
};

let firstLoad = true;

export const AccountManagementContext = createContext<AccountManagementProviderProps>(defaultValue);

function AccountManagementProvider({ children }: { children: ReactNode }) {
  const [showTable, setShowTable] = useState<boolean>(defaultValue.showTable);

  useEffect(() => {
    if (firstLoad) {
      return;
    }

    const value = sessionStorage.getItem('showAccountManagementTable');

    if (value != null) {
      setShowTable(value === 'true');
    }
  }, []);

  const handleShowTable = (payload: boolean) => {
    firstLoad = false;
    setShowTable(payload);
    sessionStorage.setItem('showAccountManagementTable', payload.toString());
  };

  const memoizedValue: AccountManagementProviderProps = useMemo(
    () => ({
      showTable,
      handleShowTable,
    }),
    [showTable, handleShowTable],
  );

  return <AccountManagementContext.Provider value={memoizedValue}>{children}</AccountManagementContext.Provider>;
}

export default AccountManagementProvider;

export const useAccountManagementProvider = (): AccountManagementProviderProps => useContext(AccountManagementContext);
